export default ( currency = '€' ) => {
  switch ( currency ) {
    case '€':
      return '0,0.00 $';
    case '$':
      return '$0,0.00';
    default:
      return '0,0.00';
  }
};
